import { RESET } from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default () => createProjectModalActions[RESET]();
